/** biome-ignore-all lint/correctness/useExhaustiveDependencies: <explanation> */
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { QUERIES } from '@/constants/queries'
import { ROLES } from '@/constants/roles'
import { ROUTES } from '@/constants/routes'
import { studentSessionValidate } from '@/services/auth/student-session-validate'
import { useStudentSessionStore } from '@/store/student-session-store'

export const useStudentAuth = () => {
  const { token } = useParams()

  const { setSession } = useStudentSessionStore()

  const navigate = useNavigate()

  const { data, isError } = useQuery({
    queryKey: [QUERIES.QUERY_STUDENT_AUTH, token],
    queryFn: () => studentSessionValidate(token),
    enabled: !!token
  })

  useEffect(() => {
    if (data) {
      setSession(
        data.access.token,
        data.access.refrehToken,
        data.student.person.name,
        data.student.ra,
        data.student.courseId,
        data.student.college.name,
        data.student.courseName,
        ROLES.STUDENT.id,
        data.student.id,
        data.student.college.collegeLogo,
        data.student.college.collegePage
      )

      navigate(`/${ROUTES.STUDENT_HOME.route}`, { replace: true })
    }
  }, [data])

  return {
    states: { isError }
  }
}
